/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Per_Unit_FixedInputs */

const en_admin_resource_form_per_unit_fixed = /** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fixed`)
};

const de_admin_resource_form_per_unit_fixed = /** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fest`)
};

const es_admin_resource_form_per_unit_fixed = /** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fijo`)
};

const fr_admin_resource_form_per_unit_fixed = /** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fixe`)
};

/** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */
const it_admin_resource_form_per_unit_fixed = en_admin_resource_form_per_unit_fixed;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */
const pt_br2_admin_resource_form_per_unit_fixed = en_admin_resource_form_per_unit_fixed;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */
const pl_admin_resource_form_per_unit_fixed = en_admin_resource_form_per_unit_fixed;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */
const hu_admin_resource_form_per_unit_fixed = en_admin_resource_form_per_unit_fixed;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_FixedInputs) => LocalizedString} */
const ro_admin_resource_form_per_unit_fixed = en_admin_resource_form_per_unit_fixed;

/**
* | output |
* | --- |
* | "fixed" |
*
* @param {Admin_Resource_Form_Per_Unit_FixedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_per_unit_fixed = /** @type {((inputs?: Admin_Resource_Form_Per_Unit_FixedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Per_Unit_FixedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "de") return de_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "es") return es_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "fr") return fr_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "it") return it_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "pl") return pl_admin_resource_form_per_unit_fixed(inputs)
	if (locale === "hu") return hu_admin_resource_form_per_unit_fixed(inputs)
	return ro_admin_resource_form_per_unit_fixed(inputs)
});
export { admin_resource_form_per_unit_fixed as "admin.resource_form.per_unit_fixed" }